<template>
  <div>
    <h3 class="text-black mb-4">Download Report</h3>
    <!-- FILTER START -->
    <panel :noExpand="true">
      <template slot="header">
        <h4 class="panel-title">Filter Option</h4>
      </template>
      <div class="row">
        <div class="col-md-4 align-items-center">
          <label for="searchBy">Report</label>
          <input v-model="filter.reportName" type="text" class="form-control" placeholder="Type report name" style="height: 42px" />
        </div>
        <div class="col-md-4 align-items-center">
          <label for="searchBy">Request By</label>
          <MultiSelect v-model="filter.requestedBy" :options="requestedByOptions" :multiple="false" :allow-empty="true" placeholder="Choose User" />
        </div>
        <div class="col-md-4 align-items-center">
          <label for="partshopCode">Status</label>
          <MultiSelect v-model="filter.status" :options="options.status.map((x) => x.title)" :multiple="false" :allow-empty="true" placeholder="Choose Status"></MultiSelect>
        </div>
        <div class="row justify-content-end px-2 py-3">
          <div class="col-md-3" style="display: flex; flex-direction: column-reverse; padding-top: 20px">
            <button class="btn button-new-1" type="button" style="height: 38px; margin-bottom: 0.5%" @click="fetchData">Search</button>
          </div>
        </div>
      </div>
    </panel>
    <!-- FILTER END -->

    <!-- <template v-if="!filter">
      <div class="bg-white py-4 radius-sm text-center">
        <img class="my-4" :src="require('@/assets/img/icon/no-filter.jpg')" alt="no-filter" />
        <p>Select and search filter to display data</p>
      </div>
    </template> -->

    <!-- <template v-else> -->
    <div class="bg-white py-4 radius-sm">
      <!-- <vue-universal-table :api_url="'/api/reports/qr-code'" @dataLoaded="handleDataLoaded" :filter="filter" :fields="vue_universal_table.fields" :buttons="vue_universal_table.buttons" :update="vue_universal_table.update" :infinite_scroll="true" @onDetails="showDetail" /> -->
      <!-- <vue-universal-table :api_url="'/api/reports/qr-code'" @dataLoaded="handleDataLoaded" :filter="filter" :fields="vue_universal_table.fields" :buttons="vue_universal_table.buttons" :update="vue_universal_table.update" :infinite_scroll="true" @onDetails="showDetail" /> -->
      <table class="table" v-if="data">
        <thead>
          <tr>
            <th>Report Name</th>
            <th>Requested By</th>
            <th>Filters Used</th>
            <th>Status</th>
            <th>Download Link</th>
            <th>File Size</th>
            <th>Requested At</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="dat in data">
            <td>{{ dat.report_name }}</td>
            <td>{{ dat.username }}</td>
            <td>{{ dat.filters }}</td>
            <td :style="{ color: statusDownload[dat.status.toLowerCase()].color }">{{ dat.status }}</td>
            <td>
              <span v-if="dat.download_url">
                <a target="_blank" rel="noopener noreferrer" :href="dat.download_url">{{ statusDownload[dat.status.toLowerCase()].label }}</a>
              </span>
              <span v-else>{{ statusDownload[dat.status.toLowerCase()].label }}</span>
            </td>
            <td>{{ dat.file_size ? dat.file_size : "-" }}</td>
            <td>{{ dat.requested_at }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- <div v-if="loading" class="text-center">
        <p>Loading...</p>
      </div>
      <template v-else-if="!isDataAvailable">
        <div class="bg-white py-4 radius-sm text-center">
          <p>Data is not available</p>
        </div>
      </template> -->
    <!-- <template v-if="!isDataAvailable">
        <div class="bg-white py-4 radius-sm text-center">
          <p>Data is not available</p>
        </div>
      </template>
    </template> -->

    <transition name="modal" v-if="showModal">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="showModal = false">
          <div class="row">
            <div class="col-xs-0 col-sm-0 col-md-2 col-lg-2"></div>
            <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
              <div class="modal-container" @click.stop>
                <div class="modal-header" style="justify-content: flex-end">
                  <button type="button" class="close" @click="showModal = false">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <div class="modal-body">
                  <h2 class="text-center">QR Code Details</h2>
                  <div class="row">
                    <div class="col-md-7 col-12">
                      <table class="table table-borderless">
                        <tbody class="border border-secondary shadow" style="border-radius: 5px !important">
                          <tr>
                            <td colspan="3" class="text-center"><h4>Vehicle Matched Details</h4></td>
                          </tr>
                          <tr>
                            <td>QR Code</td>
                            <td>:</td>
                            <td>{{ vehicleData.qrcode }}</td>
                          </tr>
                          <tr>
                            <td>Engine Number</td>
                            <td>:</td>
                            <td>{{ vehicleData.engine_no }}</td>
                          </tr>
                          <tr>
                            <td>Frame Number</td>
                            <td>:</td>
                            <td>{{ vehicleData.frame_no }}</td>
                          </tr>
                          <tr>
                            <td>Active Date</td>
                            <td>:</td>
                            <td>{{ vehicleData.active_date ? new moment(vehicleData.active_date).format("YYYY-MM-DD HH:mm:ss") : "" }}</td>
                          </tr>
                          <tr>
                            <td>Original Location</td>
                            <td>:</td>
                            <td>{{ vehicleData.ori_loc_code }}</td>
                          </tr>
                          <tr>
                            <td>Last Known Location</td>
                            <td>:</td>
                            <td>{{ vehicleData.current_loc_code }}</td>
                          </tr>
                          <tr>
                            <td>Activity Type</td>
                            <td>:</td>
                            <td>{{ vehicleData.current_activity }}</td>
                          </tr>
                        </tbody>
                        <br />
                        <tbody class="border border-secondary shadow" style="border-radius: 5px !important">
                          <tr>
                            <td colspan="3" class="text-center">
                              <h4>Vehicle Information</h4>
                            </td>
                          </tr>
                          <tr>
                            <td>Vehicle Type</td>
                            <td>:</td>
                            <td>{{ vehicleData.type_code }}</td>
                          </tr>
                          <tr>
                            <td>Commercial Name</td>
                            <td>:</td>
                            <td>{{ vehicleData.commercial_name }}</td>
                          </tr>
                          <tr>
                            <td>Segment</td>
                            <td>:</td>
                            <td>{{ vehicleData.segment }}</td>
                          </tr>
                          <tr>
                            <td>Series</td>
                            <td>:</td>
                            <td>{{ vehicleData.series }}</td>
                          </tr>
                          <tr>
                            <td>Colour</td>
                            <td>:</td>
                            <td>{{ vehicleData.color }} - {{ vehicleData.colorDescription }}</td>
                          </tr>
                          <tr>
                            <td>Manufacture Year</td>
                            <td>:</td>
                            <td>{{ vehicleData.manufacture_year }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="col-md-5 col-12 Aligner">
                      <img :src="vehicleData.bullet" v-if="vehicleData.bullet" style="height: auto; width: 500px" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="modal" v-if="showExcelModal">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="showExcelModal = false">
          <div class="row">
            <div class="col-xs-0 col-sm-0 col-md-3 col-lg-3"></div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div class="modal-container" @click.stop>
                <div class="modal-header" style="justify-content: flex-end">
                  <button type="button" class="close" @click="showExcelModal = false">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <div class="modal-body">
                  <h4>Please Select The Time Range To Generate the Excel Report</h4>

                  <p class="mt-2 mb-2" style="color: red">{{ error }}</p>

                  <flat-pickr v-model="range" :config="rangeConfig" :placeholder="!isIEMode ? 'Select Date' : null" />

                  <div class="row mt-4">
                    <div class="col-md-3 col-12">
                      <button type="button" @click="downloadExcel()" class="btn btn-success w-100">Download Excel</button>
                    </div>
                    <div class="col-md-3 col-12">
                      <button type="button" @click="showExcelModal = false" class="btn btn-danger w-100">Cancel</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import qs from "qs";
import flatPickr from "vue-flatpickr-component";
import MultiSelect from "vue-multiselect";
import moment from "moment";
import { apply } from "core-js/fn/reflect";

export default {
  data() {
    return {
      data: null,
      statusDownload: {
        requested: {
          color: "Grey",
          label: "In Queue",
        },
        processing: {
          color: "Orange",
          label: "Please Wait",
        },
        ready: {
          color: "Green",
          label: "Click Here to Download",
        },
        "data empty": {
          color: "Blue",
          label: "[No Data]",
        },
        deleted: {
          color: "Red",
          label: "[Removed]",
        },
      },
      options: {
        status: [
          { title: "Requested", value: "requested" },
          { title: "Processing", value: "processing" },
          { title: "Ready", value: "ready" },
          { title: "Data Empty", value: "data empty" },
          { title: "Deleted", value: "deleted" },
        ],
      },
      filter: {
        reportName: "",
        requestedBy: "",
        status: null,
      },
      requestedByOptions: [],
      loading: false,
    };
  },
  components: {
    MultiSelect,
    flatPickr,
  },
  mounted() {
    this.fetchData();
  },
  computed: {
    isDataAvailable() {
      return this.vue_universal_table.dataTable && this.vue_universal_table.dataTable.length > 0;
    },
  },
  watch: {
    "filter.status"(newStatus) {
      this.fetchData();
    },
  },
  methods: {
    showDetail(qrcode) {
      let url = "/api/reports/qr-code/detail/" + qrcode.replace(/"/g, "");
      console.log(url);
      this.vehicleData = null;
      this.$http
        .get(url)
        .then((resp) => {
          let listOfSeriesImage = [
            {
              name: "Genio",
              bullet: "https://cdnhonda.azureedge.net/uploads/products/25183.jpg",
            },
            {
              name: "BeAT",
              bullet: "https://cdnhonda.azureedge.net/uploads/products/63228.jpg",
            },
            {
              name: "Monkey",
              bullet: "https://cdnhonda.azureedge.net/uploads/products/89252.png",
            },
            {
              name: "Scoopy",
              bullet: "https://cdnhonda.azureedge.net/uploads/products/25324.png",
            },
            {
              name: "PCX 150",
              bullet: "https://cdnhonda.azureedge.net/uploads/products/88723.png",
            },
            {
              name: "ADV 150",
              bullet: "https://cdnhonda.azureedge.net/uploads/products/48889.jpg",
            },
            {
              name: "SHX150i",
              bullet: "https://cdnhonda.azureedge.net/uploads/products/39999.png",
            },
            {
              name: "Forza",
              bullet: "https://cdnhonda.azureedge.net/uploads/products/83922.png",
            },
            {
              name: "CRF150L",
              bullet: "https://cdnhonda.azureedge.net/uploads/products/79470.png",
            },
            {
              name: "Revo X",
              bullet: "https://cdnhonda.azureedge.net/uploads/products/67412.png",
            },
            {
              name: "Supra X",
              bullet: "https://cdnhonda.azureedge.net/uploads/products/43165.png",
            },
            {
              name: "Vario",
              bullet: "/img/Vehicle/Vario.png",
            },
          ];
          this.vehicleData = resp.data.data[0];
          for (var i = 0; i < listOfSeriesImage.length; i++) {
            if (this.vehicleData.series != null && this.vehicleData.series.toLowerCase() == listOfSeriesImage[i].name.toLowerCase()) {
              this.vehicleData.bullet = listOfSeriesImage[i].bullet;
            }
          }

          this.showModal = true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async downloadExcel(filter) {
      if (this.range == "") {
        this.error = "Please Select Time Range To Download The Excel";
        return;
      }
      let url = "/api/reports/qr-code/download-excel" + (await this.initialiseFilter());

      this.$http
        .get(url, { responseType: "blob" })
        .then((resp) => {
          const blob = new Blob([resp.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          let url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = "QR Code Data (" + this.range + ")";
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    initialiseFilter() {
      let queryArray = [];

      // Ensure `this.filter` is a valid object
      if (this.filter && typeof this.filter === "object") {
        Object.keys(this.filter).forEach((key) => {
          let value = this.filter[key];

          // If the value is empty/null, just append the key without `=`
          if (!value || value.length === 0 || value === "All") {
            queryArray.push(key);
          } else {
            queryArray.push(`${key}=${encodeURIComponent(value)}`);
          }
        });
      } else {
        console.warn("Filter is invalid or null, skipping filters.");
      }

      // Ensure `this.range` is valid
      if (this.range) {
        let splitDateRange = this.range.split(" to ");
        if (splitDateRange.length === 2) {
          queryArray.push(`start=${splitDateRange[0]}`);
          queryArray.push(`end=${splitDateRange[1]}`);
        } else {
          console.warn("Invalid date range format:", this.range);
        }
      }

      let finalQuery = queryArray.length ? "?" + queryArray.join("&") : "";
      console.log("Final URL query:", finalQuery);
      return finalQuery;
    },

    handleDataLoaded(data) {
      this.loading = false;
      if (Array.isArray(data)) {
        this.$set(this.vue_universal_table, "dataTable", data);
      } else {
        this.$set(this.vue_universal_table, "dataTable", []);
      }
    },
    async fetchData() {
      this.data = null;
      this.loading = true;
      setTimeout(async () => {
        try {
          let filters = { ...this.filter };
          // Hapus filter status dari query API
          delete filters.status;

          for (let key in filters) {
            if (filters[key] === "" || filters[key] === null) {
              delete filters[key];
            }
          }
          let response = await this.$http.get(`/api/reports/download-report${qs.stringify(filters, { skipNulls: true, addQueryPrefix: true })}`);
          let allData = response.data.data;
          // SET requestedByOptions dari unique username
          this.requestedByOptions = [...new Set(allData.map((item) => item.username))];
          // Filter report
          let filteredData = allData;
          if (this.filter.reportName) {
            const keyword = this.filter.reportName.toLowerCase();
            filteredData = filteredData.filter((item) => item.report_name && item.report_name.toLowerCase().includes(keyword));
          }
          // Filter requestedBy
          if (this.filter.requestedBy) {
            const requestedBy = this.filter.requestedBy.toLowerCase();
            filteredData = filteredData.filter((item) => item.username && item.username.toLowerCase() === requestedBy);
          }
          // Filter status
          if (this.filter.status) {
            filteredData = filteredData.filter((item) => item.status && item.status.toLowerCase() === this.filter.status.toLowerCase());
          }

          // filteredData.forEach((item) => {
          //     let filterList = item.filters.split(",").map((f) => f.trim());
          //     item.filters = filterList.filter((f) => f.startsWith("Start Date") || f.startsWith("End Date")).join(", ");
          //     item.requested_at = moment(item.requested_at).format("DD MMM YYYY HH:mm:ss"); // Perbaiki format tanggal
          // });
          filteredData.forEach((item) => {
            item.filters = item.filters;
            item.requested_at = moment(item.requested_at).format("DD MMM YYYY HH:mm:ss");
          });

          this.data = filteredData;
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          this.loading = false;
        }
      }, 1000);
    },
    // generateData () {
    //   var data = []

    //   for(var i = 0; i < 100; i++) {
    //     var createdAtDate = this.randomDate(new Date(2012, 0, 1), new Date(2017, 0, 1))
    //     var activeAtDate = this.randomDate(createdAtDate, new Date()).toISOString();
    //     createdAtDate = createdAtDate.toISOString();
    //     data.push({
    //       code : this.randomInt(0,100000000000),
    //       serial_number : this.randomInt(0,100000000000),
    //       engine_number : this.randomInt(0,100000000000),
    //       status : (this.randomInt(0,10)%2 == 1) ? 'ACTIVE' : 'INACTIVE',
    //       active_date : activeAtDate.split("T")[0] + " " + activeAtDate.slice(11,19),
    //       created_at : createdAtDate.split("T")[0] + " " + createdAtDate.slice(11,19)
    //     })
    //   }

    //   this.data = data;
    // }
  },
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 1020;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 100%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
  * The following styles are auto-applied to elements with
  * transition="modal" when their visibility is toggled
  * by Vue.js.
  *
  * You can easily play with the modal transition by editing
  * these styles.
  */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

/* MODAL STARTS */
.modal-body {
  margin: 0;
}

.modal-body .moduleLine {
  margin-bottom: 0vh;
}

.modal-body .moduleLine a {
  text-decoration: none;
}

.modal-body .moduleLine .moduleBox:hover {
  background-color: #e0e0e0;
  transition: background-color 0.7s ease;
  color: #212121;
  transition: color 0.7s ease;
}

.modal-body .moduleLine .moduleBox {
  border: 1px solid #bdbdbd;
  border-radius: 20px;
  padding: 20px 0;
  color: black;
  margin-bottom: 3vh;
}

.modal-body .moduleLine .moduleBox i {
  font-size: 5vh;
}

h3.modalHeadline {
  margin: 0 0 20px 0;
  font-weight: bold;
  text-align: center;
}
/* MODAL ENDS */

.table tr th {
  white-space: nowrap;
}
</style>
